import { useState,useEffect } from 'react';
import { Grid2,Typography } from '@mui/material';
import moment from 'moment';
import dayjs from 'dayjs';

import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import tr from "../../Assets/Images/tr.svg";
import settlement from "../../Assets/Images/settlement.svg";
// import { httpRequest } from '../../ui-utils/api';
import HolidayStyles from "./Holiday.module.css"
import axios from 'axios';
import { DateCalendar } from '@mui/x-date-pickers';
import DocumentMeta from 'react-document-meta'
const meta = {
    title: 'Trading Holidays | NSE, BSE & CDSL Updates | TradeBoss',
    description: 'Stay updated with TradeBoss NSE & BSE trading holiday calendar. Never miss a market day.',
    canonical: 'https://tradeboss.co/holiday_calendar, https://tradeboss.co/circular,  https://tradeboss.co/issue_disclosures, https://tradeboss.co/bulletin',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'NSE trading holidays, BSE holiday calendar, stock market holidays India, trading holiday schedule, market closure dates'
        }
    }
}
const Holiday = () => {
    const [userdata, setUserdata] = useState([]);
    const [hdesp, setHdesp] = useState('');
    const [hmsg, setHmsg] = useState('');
    const [caldate, setCaldate] = useState(dayjs('2023-09-01'));
    const [holidays, setHolidays] = useState([]);
     const [selectedDate, setSelectedDate] = useState(dayjs());







    useEffect(() => {
        const fetchHolidayData = async () => {
            let userdata1 = [];
            const currenDate = moment(new Date()).format("MM/DD/YYYY");
            const endDate = moment(currenDate, "MM/DD/YYYY");

            try {
                const cal_list =await axios.get(`https://bullforce-trader-admin-backend.bullforce.co/api/calander/get_holidaylist`)
                console.log(cal_list.data.data)
                const allHolidays = cal_list.data.data.map((ele) => ({
                    date: moment(ele.h_date).format("YYYY-MM-DD"),
                    type: ele.otype
                }));
                console.log("holiday",allHolidays)
                setHolidays(allHolidays);

                let a = 0;
                cal_list.data.data.forEach(data => {
                    const hdate = moment(data.h_date).format("MM/DD/YYYY");
                    const result = endDate.diff(hdate, 'days');
                    let b = 0;

                    if (a === 0 && result <= 0) {
                        a = 1;
                        b = 1;
                        const daysUntil = parseInt(result) * -1;
                        setHmsg(`${daysUntil} Days (${moment(data.h_date).format("ddd, DD MMM")}`);
                        setHdesp(data.occasion);
                        setCaldate(dayjs(moment(data.h_date).format("YYYY-MM-DD")));
                    }

                    userdata1.push({
                        ha_date: moment(data.h_date).format("ddd, DD MMM YYYY"),
                        occasion: data.occasion,
                        exchange: data.exchange,
                        otype: data.otype,
                        a: b
                    });
                });

                setUserdata(userdata1);
            } catch (error) {
                console.error("Error fetching holiday data:", error);
            }
        };

        fetchHolidayData();
    }, []);

const ServerDay = (props) => {
  const { day, selected, ...other } = props;
  const formattedDay = day.format('YYYY-MM-DD');
  const formattedToday = new Date().toISOString().split('T')[0]; // Today's date
  const isToday = formattedDay === formattedToday;

  const holiday = holidays.find((h) => h.date === formattedDay);
  const isHoliday = !!holiday;
  const holidayType = isHoliday ? holiday.type : null;

  return (
    <PickersDay
      {...other}
      day={day}
      disabled={!isToday}
      selected={false}
      style={{

        color: 'black',


        backgroundColor: 'white',


        ...(isHoliday && {
          backgroundColor:
            holidayType === 'TRADING' ? '#F74542' : '#517AAF',
          color: 'white',
        }),


        ...(isToday && !isHoliday && {
          backgroundColor: 'white',
          color: 'black',
        }),

        '&.Mui-disabled': {
          color: 'black',
          opacity: 1,
        },
      }}
    />
  );
};


    return (
        <main className={HolidayStyles.holiday_calendar_container}>
            <DocumentMeta {...meta} />
            <div className={HolidayStyles.holiday_header}>
                <div className={HolidayStyles.card1}>
                    <div className={HolidayStyles.card2}>
                        <Grid2 style={{ display: 'flex', alignItems: 'center', marginBottom: '2%' }}>
                            <Typography className={HolidayStyles.tit} style={{ marginLeft: '5px' }}>
                                The next trading holiday is in {hmsg} {hdesp})
                            </Typography>
                        </Grid2>
                    </div>
                    <div className={HolidayStyles.card3}>
                        <Grid2 style={{ display: 'flex', alignItems: 'center', marginBottom: '2%' }}>
                            <div className={HolidayStyles.trading_indicator}></div>
                            <Typography className={HolidayStyles.leg} style={{ marginLeft: '5px' }}>TRADING</Typography>
                            <div className={HolidayStyles.settlement_indicator} style={{ marginLeft: '15px' }}></div>
                            <Typography className={HolidayStyles.leg} style={{ marginLeft: '5px' }}>SETTLEMENT</Typography>
                        </Grid2>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div className={HolidayStyles.card4}>
                    <div className={HolidayStyles.card5}>
                        {userdata.map((label, index) => (
                            <Grid2 key={index} className={HolidayStyles.holiday_item}>
                                <Grid2 style={{ width: '5%' }}>
                                    <img src={label.otype === "TRADING" ? tr : settlement} alt="holiday type" />
                                </Grid2>
                                <Grid2 style={{ width: '20%', marginLeft: '1%' }}>
                                    <Typography className={HolidayStyles.tit_label}>{label.ha_date}</Typography>
                                </Grid2>
                                <Grid2 style={{ width: '50%', display: 'flex', alignItems: 'center' }}>
                                    {label.a === 10 && (
                                        <div className={HolidayStyles.next_holiday_indicator}></div>
                                    )}
                                    <Typography className={HolidayStyles.tit_label} style={{ paddingLeft: '20px' }}>
                                        {label.occasion}
                                    </Typography>
                                </Grid2>
                                <Grid2 style={{ width: '20%' }}>
                                    <div style={{ display: 'flex' }}>
                                        {label.exchange.split(',').map((data, index1) => (
                                            data !== "MCX" && (
                                                <div key={index1} style={{ padding: '0px 5px' }}>
                                                    <Typography className="tit_label">{data}</Typography>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </Grid2>
                            </Grid2>
                        ))}
                    </div>
                    <div className={HolidayStyles.card6}>
                        <div className={HolidayStyles.calendar_container}>
     <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DateCalendar
    value={selectedDate}
    onChange={(newValue) => setSelectedDate(dayjs(newValue))}
    slots={{
      day: ServerDay, // Custom Day Component
    }}
  />
</LocalizationProvider>

    </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Holiday;